import { render, staticRenderFns } from "./TeamChild.vue?vue&type=template&id=3cbbad78&scoped=true"
import script from "./TeamChild.vue?vue&type=script&lang=js"
export * from "./TeamChild.vue?vue&type=script&lang=js"
import style0 from "./TeamChild.vue?vue&type=style&index=0&id=3cbbad78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbbad78",
  null
  
)

export default component.exports